import type { Locale } from '@shaojiang/types/i18n';

import { en } from './en';
import type { SiteCopy, Text } from './types';
import { zh } from './zh';

export type { SiteCopy, Text } from './types';

const copies: Record<Locale, SiteCopy> = { en, zh };

/** All UI copy for a locale (typed, so a missing translation fails the build). */
export const getCopy = (locale: Locale): SiteCopy => copies[locale] ?? en;

/** Fills `{name}` placeholders: `fill('All {n} stories', { n: 22 })`. */
export function fill(template: string, values: Record<string, string | number>) {
  return template.replace(/\{(\w+)\}/g, (match, key) =>
    key in values ? String(values[key]) : match,
  );
}

/** Fills placeholders in every design's wording of a piece of copy. */
export function fillText(text: Text, values: Record<string, string | number>): Text {
  if (typeof text === 'string') return fill(text, values);
  return Object.fromEntries(
    Object.entries(text).map(([design, value]) => [design, fill(value, values)]),
  ) as Text;
}
